import Theme from "@/domain/entities/user/Theme";
import { Theme as ThemeMailvista } from "@cs_teamwaydev/mailvista-sdk_react";

const themeToDomainMapper = (theme: ThemeMailvista): Theme =>
    new Theme({
        darkMode: theme.darkMode,
        image: theme.image,
        backgroundColor: theme.backgroundColor,
        backgroundImageUrl: theme.backgroundImageUrl,
        useCustomImage: theme.useCustomImage,
    });

const themeToSDKMapper = (theme: Theme): ThemeMailvista => ({
    darkMode: theme.darkMode,
    image: theme.image,
    backgroundColor: theme.backgroundColor,
    backgroundImageUrl: theme.backgroundImageUrl,
    useCustomImage: theme.useCustomImage,
});

export { themeToDomainMapper, themeToSDKMapper };
